import { useState, useEffect } from 'react'

export function useKlapScript() {
  const [isReady, setIsReady] = useState(false)
  const [error, setError] = useState(null)

  useEffect(() => {
    const src = import.meta.env.VITE_KLAP_SDK_URL
    if (!src) {
      setError('VITE_KLAP_SDK_URL no está definida')
      return
    }

    // Si ya está cargado (otro componente lo cargó antes), reusar
    const existing = document.querySelector(`script[src="${src}"]`)
    if (existing) {
      if (window.KLAP_FLEX) {
        definePayKlapOrder()
        setIsReady(true)
      } else {
        existing.addEventListener('load', () => {
          definePayKlapOrder()
          setIsReady(true)
        })
        existing.addEventListener('error', () => setError('Error al cargar el script de Klap'))
      }
      return
    }

    const script = document.createElement('script')
    script.src = src
    script.type = 'text/javascript'
    script.onload = () => {
      definePayKlapOrder()
      setIsReady(true)
    }
    script.onerror = () => setError('Error al cargar el script de Klap')
    document.head.appendChild(script)

    return () => {
      // Solo remover si no hay otros consumidores activos
      // Dejamos el script en el DOM para evitar re-descargas en el mismo session
    }
  }, [])

  return { isReady, error }
}

function definePayKlapOrder() {
  if (!window.payKlapOrder) {
    window.payKlapOrder = function (order_id) {
      KLAP_FLEX.init({ orderId: order_id, useModal: true })
    }
  }
}
